const PLACEHOLDER_HEADER_IMAGE =
  'f35a26_6cc328fb763841249ba03010e0f678f5~mv2.jpg';

export const getHeaderImageSrc = (): string => PLACEHOLDER_HEADER_IMAGE;
